(() => {
  const root = document.querySelector('[data-pdp-hero]');
  if (!root) return;

  const cta = root.querySelector('[data-pdp-cta]');
  const label = root.querySelector('[data-pdp-cta-label]');
  if (!cta) return;

  const variantId = cta.dataset.variantId;
  const cartUrl = cta.dataset.cartUrl || '/cart';

  const openPopup = (item) => {
    document.dispatchEvent(new CustomEvent('nd:added-popup', { detail: item }));
  };

  const refreshCart = async (added) => {
    try {
      const [{ CartLinesUpdateEvent }, { morphSection }] = await Promise.all([
        import('@shopify/events'),
        import('@theme/section-renderer'),
      ]);

      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'update',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: 1 }],
          promise: deferred.promise,
        })
      );

      const cartJson = await fetch(`${cartUrl}.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((response) => response.json());

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cartJson),
        detail: {
          items: cartJson.items,
          itemCount: cartJson.item_count,
          source: 'pdp-add-confirm',
          sections: added.sections || {},
          didError: false,
        },
      });

      const drawerHtml = added.sections && added.sections['cart-drawer-section'];
      if (drawerHtml) {
        await morphSection('cart-drawer-section', drawerHtml, {
          mode: 'hydration',
          injectStylesheet: true,
        });
      }

      const match = (cartJson.items || []).find((item) => String(item.variant_id) === String(variantId));
      return match ? match.quantity : 1;
    } catch (error) {
      console.warn('[pdp-add-confirm] cart refresh failed', error);
      return 1;
    }
  };

  const addToCart = async () => {
    if (!variantId || cta.classList.contains('is-busy')) return;
    cta.classList.add('is-busy');
    if (label) label.textContent = 'Adding...';

    try {
      const body = new FormData();
      body.append('id', String(variantId));
      body.append('quantity', '1');
      body.append('sections', 'cart-drawer-section');
      body.append('sections_url', window.location.pathname);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        body,
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Add failed');
      }

      await refreshCart(data);
      openPopup({
        product_title: data.product_title || data.title,
        title: data.title,
        image: data.image,
        price: data.final_price || data.price,
        quantity: data.quantity || 1,
      });
    } catch (error) {
      console.warn('[pdp-add-confirm] add failed', error);
      if (label) label.textContent = 'Try again';
      window.setTimeout(() => {
        if (label) label.textContent = 'Add to Cart';
      }, 1600);
    } finally {
      cta.classList.remove('is-busy');
      if (label && label.textContent === 'Adding...') label.textContent = 'Add to Cart';
    }
  };

  cta.addEventListener('click', (event) => {
    event.preventDefault();
    addToCart();
  });
})();
